import { TriggerEventType } from '@/constant/triggerEventType';

/** 加购弹窗模板默认广告图（案例展示 / 动态替换说明合成图） */
export const ADD_CART_SAMPLE_PRODUCT_IMG =
  'https://dvamghaolyr74.cloudfront.net/Public/img/30/7eaeab2c65e7791a17b0d44aa09c7d30tkmqbk.png';

/**
 * 从模板创建加购弹窗时，把广告图字段统一写成案例展示图。
 * 左/右/中/上图共用 imgUrl，切位置不会换 URL。
 */
export function applyAddCartSampleProductImage(formData: any): void {
  if (!formData?.settings || Number(formData.triggerEventType) !== TriggerEventType.ADD_TO_CART) {
    return;
  }

  const typesetting = {
    ...(formData.settings.typesetting || {}),
  };

  typesetting.imgUrl = ADD_CART_SAMPLE_PRODUCT_IMG;

  if (typesetting.middleImgUrl) {
    typesetting.middleImgUrl = ADD_CART_SAMPLE_PRODUCT_IMG;
  }
  if (typesetting.imgUrlEnd) {
    typesetting.imgUrlEnd = ADD_CART_SAMPLE_PRODUCT_IMG;
  }

  formData.settings.typesetting = typesetting;
}
